import { hookstate } from '@hookstate/core';
import { createContext } from 'react';

export const globalBlockedState = hookstate(false);
export const UserContext = createContext(null);
export const ToastContext = createContext(null);
